
import TeamTeam from '../team/team.js';

export default class MasterTeam extends TeamTeam {

  constructor({ id, sessionId, name }) {
    super({ id, sessionId, name });
  }
}
